// Libraries
import React from 'react';
import { Form, Formik } from 'formik';
import { Button } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
// Components
import { TextInput } from '../../base/forms/TextInput';
// Actions
import ShowNotification from '../../../actions/notification';
// Services
import { sendAutomatedPatientSurveys } from '../../../services/administration';
// Schema
import { automatedPatientSurveysSchema } from '../../../constants/forms/schemas/adminOtherPage';
// Constants
import { NOTIFICATION_TYPE } from '../../../constants/constants';
// Local Constants
const DEFAULT_VALUES = { user: '' };


export const AutomatedPatientSurveys = () => {
  const dispatch = useDispatch();
  const showNotification = data => dispatch(ShowNotification(data));

  const processData = async (data) => {
    const sendAutomatedPatientSurveysRequest = sendAutomatedPatientSurveys(data);
    const sendAutomatedPatientSurveysPromise = sendAutomatedPatientSurveysRequest.promise;

    try {
      await sendAutomatedPatientSurveysPromise;
      delete sendAutomatedPatientSurveysRequest.promise;
      showNotification({
        message: 'Service successfully executed',
        autoHide: true,
        notificationType: NOTIFICATION_TYPE.SUCCESS,
      });
    } catch (error) {
      delete sendAutomatedPatientSurveysRequest.promise;
      if (error.isCanceled || error.status === 401 || error.status === 403) {
        return;
      }
      showNotification({
        message: 'An error occurred. Please try again.',
        autoHide: true,
        notificationType: NOTIFICATION_TYPE.ERROR,
      });
    }
  };

  return (
    <div className="">
      <Formik
        initialValues={DEFAULT_VALUES}
        validationSchema={automatedPatientSurveysSchema()}
        onSubmit={values => processData(values)}
        data-test="automatedPatientSurveys_formikComponent"
      >
        {formik => (
          <Form className="container-fluid w-100 text-left">
            <div className="row">
              <div className="col-4">
                <TextInput
                  type="text"
                  label="Username"
                  name="user"
                  autoComplete="off"
                />
              </div>
            </div>
            <div className="row">
              <div className="col">
                <Button
                  variant="primary"
                  disabled={!formik.isValid}
                  onClick={() => formik.handleSubmit()}
                  className="text-capitalize"
                  data-test="automatedPatientSurveys_saveBtn"
                >
                  automate
                </Button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default AutomatedPatientSurveys;
